import { PageModel } from './Page'

export interface MessageInfoModel {
  messageConfigRsp: MessageConfigRspModel
  unreadNum: number
}

export interface MessageUnreadInfoModel {
  sysNum: number
  commentNum: number
  dynamicNum: number
}

export interface MessageConfigRspModel {
  bind: number
  buy: number
  comments: number
  craft: number
  desktopNotifications: number
  follows: number
  gifts: number
  likes: number
  mint: number
  open: number
  priceAlert: number
  sell: number
}

export const enum MESSAGE_TYPE {
  'Event' = 0,
  'Community' = 1,
  'Notification' = 2,
}

export const MESSAGE_TITLE = ['Event', 'Community', 'Notification']
export const MESSAGE_TRACK_TYPE = ['promotion', 'community', 'system', 'yeeha']

export interface MessageModel {
  id: number
  type: number
  banner: string
  title: string
  content: string
  unreadNum: number
  createTime: string
  readFlag: number
  url: string
  extra: string
  userRsp: {
    headIcon: string
    nickName: string
    uid: string
  }
}

export interface MessageListModel extends PageModel {
  records: Array<MessageModel>
}
